export const getCurrentYear = () => {
  return new Date().getFullYear();
};

export const getNextYear = () => {
  return getCurrentYear() + 1;
};

export const getPreviousYear = () => {
  return getCurrentYear() - 1;
};

export const getPreviousYearByYear = (year: string) => {
  return Number(year) - 1;
};

export const getYearOptions = (startYear: number) => {
  const currentYear = getCurrentYear();
  return Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
    const year = startYear + i;
    return {
      id: year,
      text: year.toString(),
    };
  });
};
